import * as React from "react";
// import {useState} from 'react'
import { Grid, Typography } from "@material-ui/core";

import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { Box } from "@mui/system";

import spinner from "../../../utils/assests/spinner.gif";
import { useHistory } from "react-router";
import { CD_LOAN_OFFER } from "../../../utils/urls";
import axios from "../../../utils/http";
import Header from "../../../Common/header";
import Loader from "../../../Common/Loader";

const useStyles = makeStyles((theme: Theme) => 
  createStyles({
    boxRoot: {
      "@media (min-width: 1280px)": {
        height: "100vh",
        padding: "10px",
        border: "1px transparent grey",
        boxShadow: "0 24px 55px 10px rgb(13 12 12 / 30%)",
        borderRadius: "5px",
      },
      [theme.breakpoints.down("xs")]: {
        height: "100vh",
        padding: "10px",
      },
      [theme.breakpoints.between("sm", "md")]: {
        height: "100vh",
        padding: "10px",
      },
    },
    img: {
      margin: "70px 0px 40px 0px",
    },
    root: {
      padding: "5px 45px",
      borderRadius: "19px",
      backgroundColor: "#DA222C",
      color: "#fff",
      margin: "25px",
    },
  })
);

export default function CheckEligibility() {
  const classes = useStyles();
  const history = useHistory();
  const [loader, setLoader] = React.useState(true);

  const historyState: any = history.location.state;
  const application_id =
    historyState?.application_id; /*"f0813d82-d897-4606-a2a5-52ebc6a55b38"*/
  // if(historyState==undefined){
  //     history.push('/dashboard')
  // }
  const onContinue = async (value: any) => {};
  React.useEffect(() => {
    axios
      .post(CD_LOAN_OFFER, { cd_application_id: application_id })
      .then((res) => {
        setLoader(false);
        if (res.data.results == "Loan Status Pending") {
          history.push("/pending");
        } else if (res.data.results == "Loan Rejected") {
          history.push("/reject");
        } else if (typeof res.data.results == "object") {
          history.push("/congratulation", {
            cd_loans: res.data.results,
            application_id,
          });
        }
      })
      .catch((error) => {
        setLoader(false);
      });
  }, []);
  return loader ? (
    <Loader loading={true} />
  ) : (
    <div>
      <div>
        <Header pageName="Eligibility" />
      </div>
      <Grid
        container
        direction="column"
        alignItems="center"
        justifyContent="center"
      >
        <Grid container justifyContent="center">
          <Grid item xs={12} sm={6} md={3} lg={3}>
            <Box
              className={classes.boxRoot}
              mt={5}
              component="div"
              textAlign="center"
            >
              <Box component="div" mt={2}>
                <img
                  src={spinner}
                  className={classes.img}
                  alt="pending status"
                  height="120"
                  width="120"
                />
              </Box>
              <Box component="div">
                <Typography variant="h6">
                  {"We are accessing your loan eligibility"}
                </Typography>
              </Box>
              <Box component="div" mt={5}>
                <Typography style={{ fontSize: "13px" }}>
                  {"This can take up to 30 seconds."}
                </Typography>
              </Box>

              <Box component="div" mt={5}>
                <Typography style={{ fontSize: "12px", marginTop: "100px" }}>
                  {"This may take a few seconds."}
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}
